<template>
<div class="StepFour">
    <div class="msg">
      <div class="success" v-if="fileInfo.reportstatus == 1">
        <img :src="require('@/common/images/gujingimgs/icon_other.png')" alt="">
        <p class="title">您的股权激励报告已生成，点击下方按钮进行查看。</p>
        <p>此结果根据您填入的数据计算得出，人工智能生成结果仅供参考。</p>
        <el-button type="primary" @click="select">查看报告</el-button>
      </div>
      <div class="error" v-else-if="fileInfo.reportstatus == 0">
        <img src="http://img.capwhale.com/gj_dyh.jpg" alt="">
        <p class="title">很抱歉报告生成失败，扫码添加微信客服获取报告。</p>
      </div>
    </div>
    <div v-if="recommendCourseData.length > 0" class="bottom_div">
        <div class="title_box">
            <p>为您推荐以下股权课程</p>
            <span @click="moreClick">更多 ></span>
        </div>
        <div class="recommend_box">
            <div @click="courseClick(item)" v-for="(item, index) in recommendCourseData" :key="index" class="recommend__item_div">
                <!-- <img :src="require('@/common/images/header/test.jpg')" alt=""> -->
                <img v-lazy="item.coverurl" :alt="item.subject">
                <p>{{item.subject}}</p>
            </div>
        </div>
    </div>

    

</div>
</template>

<script>
import $ from 'jquery'
import {getRecommendCourse} from 'api/gujingApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'StepFour',
    props: ['fileInfo'],
    data() {
        return {
            pdfUrl: '',
            // inputValue: '',
            recommendCourseData: [],
            
        }
    },
    mounted() {
        $('html').scrollTop(0)
        this.findRecommendCourse()
    },
    methods: {
        // 查看报告
        select() {
            this.$router.push({
                name: "SelectExcitation",
                query: {
                    fullurl: this.fileInfo.fullurl,
                    orderno: this.fileInfo.orderno
                }
            })
        },
        // 获取股鲸推荐课程
        findRecommendCourse() {
            this.setLoading(true)
            let params = {}
            getRecommendCourse({
                data: Object.assign({}, params),
                success: data => {
                    // console.log(data)
                    this.setLoading(false)
                    this.recommendCourseData = data.data.content
                },
                error: data => {
                    this.$message.error(data.msg)
                }
            })
        },
        // 更多课程
        moreClick() {
            if (this.user.loginToken) {
                window.open(`${this.domainlist.url_course}/search?catecode=01&typeData=0102&token=${this.user.loginToken}`)
            } else {
                window.open(`${this.domainlist.url_course}/search?catecode=01&typeData=0102`)
            }
        },
        // 点击推荐课程
        courseClick(val) {
            // window.open(`http://local.ke.capwhale.com:6001/coursedetails?cid=${val.courseid}&token=${this.user.loginToken}`)
            if (this.user.loginToken) {
                window.open(`${this.domainlist.url_course}/coursedetails?cid=${val.courseid}&token=${this.user.loginToken}&chid=${this.channelid}`)
            } else {
                window.open(`${this.domainlist.url_course}/coursedetails?cid=${val.courseid}&chid=${this.channelid}`)
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user',
            'domainlist',
            'channelid'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" scoped>
.StepFour {
    // width: 1200px;
    margin: 0 auto;
    background-color: rgb(255, 255, 255);
    box-sizing: border-box;
    // padding: 0 11px;
    // font-family:PingFangSC-Regular,PingFang SC;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    

    .bottom_div {
        flex: 1;
        .title_box {
            display: flex;
            justify-content: space-between;
            margin-top: 42px;
            margin-bottom: 30px;
            line-height:26px;
            &>p {
                font-size:18px;
                color: #666;
            }
            &>span {
                font-size:14px;
                cursor: pointer;
                color: #999;
            }
        }
        .recommend_box {
            display: flex;
            padding-bottom: 20px;
            .recommend__item_div {
                width: 226px;
                margin-right: 12px;
                margin: 0 6px;
                padding-bottom: 12px;
                &>img {
                    border-radius: 4px 4px 0 0;
                    width: 226px;
                    height: 128px;
                    margin-bottom: 12px;
                    cursor: pointer;
                    background: #f2f2f2;
                }
                &>p {
                    padding: 0 5px;
                    text-align: justify;
                    cursor: pointer;
                    line-height:24px;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
            }
            .recommend__item_div:hover{
                transition: all .3s;
                -moz-transition: all .3s;
                -o-transition: all .3s;
                -ms-transition: all .3s;
                -webkit-transition: all .3s;
                box-shadow: 0 0 8px 1px rgba(0, 0, 0, .1);
                -moz-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .1);
                -o-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .1);
                -ms-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .1);
                -webkit-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .1);
            }
            .recommend__item_div:nth-of-type(1){
                margin-left: 0;
            }
            .recommend__item_div:nth-last-of-type(1){
                margin-right: 0;
            }
        }
    }
    .msg {
      margin-top: 50px;
      text-align: center;
      img {
        margin: auto;
        width: 110px;
      }
      p {
        margin-top: 12px;
        color: #999;
        &.title {
          margin-top: 30px;
          color: #333;
        }
      }
      .el-button {
        margin-top: 28px;
        width:280px;
        height:48px;
        border:1px solid rgba(213,217,224,1);
      }
    }
}
</style>
<style lang="scss" scoped>
    .download_report_pop {
        .el-dialog__wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: left;
        }
        .el-dialog {
            margin: 0!important;
            width: 380px;
            border-radius: 6px;
            overflow: hidden;
        }
        .el-dialog__header {
            padding: 0!important;
            height: 40px;
            display: flex;
            align-items: center;
            .el-dialog__title {
                font-size: 14px;
                line-height:20px;
                padding-left: 20px;
            }
            .el-dialog__headerbtn {
                font-size: 20px;
                top: 10px;
            }
        }
        .el-dialog .el-dialog__body {
            padding-top: 20px;
            box-sizing: border-box;
        }
        .pop_content_box {
            display: flex;
            flex-direction: column;
            align-items: center;
            &>img {
                width: 114px;
                height: 75px;
                margin-bottom: 28px;
            }
            &>p {
                color: #333;
                line-height:24px;
                text-align: center;
                margin-bottom: 30px;
            }
            .el-button {
                width: 280px;
                height: 48px;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0;
            }
        }
    }
</style>